export const MAX_CHARACTER_LENGTH = 146;
